/* =========================================================================  */
/* Methods(s) */
/* =========================================================================  */

/**
 * @function findModuleAnchors
 * @param {*} data
 * @returns {array}
 * Finds all anchor modules
 */
export const findModuleAnchors = (data) => {
    let anchors = [];
    if (Array.isArray(data)) {
        data.forEach((d) => {
            anchors = anchors.concat(findModuleAnchors(d));
        });
    } else if (data && typeof data === 'object' && data.__typename) {
        switch (data.__typename) {
        case 'AnchorBlock':
            anchors.push(data);
            break;
        default:
            Object.keys(data).forEach((k) => { anchors = anchors.concat(findModuleAnchors(data[k])); });
            break;
        }
    }
    return anchors;
};

/**
 * @function getAllModules
 * @param {*} data
 * @returns {array}
 * Concatenates all module arrays
 */
export const getAllModules = (page) => {
    if (!page) {return null;}
    let modules = [];
    Object.keys(page).map(key => {
        if(key === 'modules') {
            modules = [...modules, ...page[key]];
        }
    });

    return modules;
};
